import { useAuth } from '../../../use';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const auth = useAuth();
const actions = new Actions('subQuestion', 'subQuestions');

const customActions = {
  async LOAD_subQuestions({ rootGetters, commit }, questionId) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('subQuestions')
      .query({
        $filter: `IsDeleted eq false AND questionId eq ${questionId}`,
        $orderby: 'created desc',
      });
    commit('SET_subQuestions', data);
    return data;
  },
};

export default { ...actions, ...customActions };
